'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _moment = _interopRequireDefault(require("moment"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _PictureAsPdf = _interopRequireDefault(require("@material-ui/icons/PictureAsPdf"));
var _Routes = require("Shared/Routes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
_moment.default.locale('fr');
let app = window.app;
class JobAdsFrontList extends _react.Component {
  state = {
    loading: false
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    const candidate_id = app.state?.session?.user?.id;
    component.fetchJobAdsAndCompany(candidate_id);
  }
  fetchJobAdsAndCompany = candidate_id => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/jobad/get-all-with-company', {
      candidate_id: candidate_id
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        jobads: response.jobads
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let list = (state.jobads || []).filter(jobad => jobad.status === "Ouverte").map(function (jobad) {
      let output = /*#__PURE__*/_react.default.createElement(_Link.default, {
        className: "c-candidate-list__item",
        href: "/annonces/" + jobad.id
      }, /*#__PURE__*/_react.default.createElement("h2", {
        className: "c-candidate-list__item__title"
      }, jobad.title, " - ", jobad._company.company_name), /*#__PURE__*/_react.default.createElement("p", {
        className: "c-circle-decoration c-circle-decoration--blue"
      }, "Type de contrat : ", jobad.contract_type), /*#__PURE__*/_react.default.createElement("p", {
        className: "c-circle-decoration c-circle-decoration--orange"
      }, "Salaire : ", jobad.salary), /*#__PURE__*/_react.default.createElement("p", {
        className: "c-circle-decoration c-circle-decoration--green"
      }, "Domaine professionnel : ", jobad._professional_domain.label), /*#__PURE__*/_react.default.createElement("p", {
        className: "c-circle-decoration c-circle-decoration--pink"
      }, jobad?.duration_type), /*#__PURE__*/_react.default.createElement("p", {
        className: "c-candidate-list-details__location"
      }, jobad?.address?.postal_code));
      return output;
    });
    let output = /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidate-list"
    }, list);
    return output;
  }
}
exports.default = JobAdsFrontList;
